import { Select, Form } from "antd";
import "./style.css"

export const UISelectInput = (props: any) => {

  const { Option } = Select;
  const {
    className,
    bordered,
    onChange,
    optionValue,
    value,
    placeholder,
    optionClass,
    mode,
    label,
    initialValue,
    name,
    rules,
    disabled,
    showSearch,
    refer
  } = props;

  return (
    <Form.Item
      label={label}
      name={name}
      rules={rules}
      className={className ? `${className} ib-0` : "ib-0"}
      initialValue={initialValue}
    >
      <Select
        disabled={disabled}
        className="custom"
        bordered={bordered}
        onChange={onChange}
        value={value}
        mode={mode}
        // defaultValue={initialValue}
        dropdownClassName="dropdown"
        placeholder={placeholder}
        showSearch={showSearch}
        showArrow
        maxTagCount="responsive"
        filterOption={(input: any, option: any) =>
          option.children.toLowerCase().startsWith(input.toLowerCase())
        }
        getPopupContainer={(trigger:any)=>trigger.parentNode}
        ref={refer}
        allowClear
      >
        {optionValue?.map((option: any, index: any) => {
          return (
            <Option
              value={option.value}
              key={option.value}
              className={optionClass ? `optionClass` : "options"}
            >
              {option.text}
            </Option>
          );
        })}
      </Select>
    </Form.Item>
  );
};

